import { isProfileMode } from "utils/productUtils"

export const VARIANTS = {
  rareHeader: {
    color: "white",
    width: "195px",
    height: "22px",
  },
  header: {
    color: "white",
    width: isProfileMode() ? "100px" : "auto",
    height: "21px",
  },
  account: {
    color: "#323c44",
    width: "150px",
    height: "32px",
  },
  large: {
    color: "#323c44",
    width: "216px",
    height: "48px",
  },
  logo: {
    height: "50px",
  },
}

export const MOBILE_VARIANTS = {
  rareHeader: {
    height: "22px",
  },
  header: {
    height: "21px",
  },
  account: {
    height: "32px",
  },
  large: {
    height: "29px",
  },
  logo: {
    height: "50px",
  },
}
